import { FuseNavigationItem } from '@fuse/components/navigation/navigation.types';

const getFactoryRelatedNavigationForMobile = (baseUrl: string = ''): FuseNavigationItem[] => {
  const navigationList: FuseNavigationItem[] = [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'basic',
      link: `${baseUrl}/dashboard`,
      exactMatch: true
    },
    {
      id: 'footprint',
      title: 'Footprint',
      type: 'basic',
      link: `${baseUrl}/footprint`
    },
    {
      id: 'kpi',
      title: 'KPI',
      type: 'basic',
      link: `${baseUrl}/kpi`
    },

    {
      id: 'kpi-compare',
      title: 'KPI Compare',
      type: 'basic',
      link: `${baseUrl}/kpi-compare`
    },

    {
      id: 'implementation-plan',
      title: 'Implementation Plan',
      type: 'basic',
      link: `${baseUrl}/implementation-plan`
    },
    {
      id: 'esg',
      title: 'ESG',
      type: 'collapsable',
      children: [
        {
          id: 'esg-social',
          title: 'Social Module',
          type: 'basic',
          link: `${baseUrl}/esg/esg-social`
        },
        {
          id: 'esg-governance',
          title: 'Governance Module',
          type: 'basic',
          link: `${baseUrl}/esg/esg-governance`
        }
      ]
    },
    {
      id: 'project',
      title: 'Project',
      type: 'basic',
      link: `${baseUrl}/project`
    },
    {
      id: 'connection',
      title: 'Connection',
      type: 'basic',
      link: `${baseUrl}/connection`
    },
    {
      id: 'subscription',
      title: 'Subscription',
      type: 'basic',
      link: `${baseUrl}/subscription`
    }
  ];

  return navigationList;
};

const getFactoryRelatedNavigationForDesktop = (baseUrl: string = ''): FuseNavigationItem[] => {
  const navigationList: FuseNavigationItem[] = [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'basic',
      icon: 'mat_solid:dashboard',
      link: `${baseUrl}/dashboard`,
      exactMatch: true
    },
    {
      id: 'home',
      title: 'Tracking',
      type: 'collapsable',
      icon: 'mat_solid:insights',
      link: `${baseUrl}/footprint`,
      children: [
        {
          id: 'footprint',
          title: 'Footprint',
          type: 'basic',
          link: `${baseUrl}/footprint`
        },
        {
          id: 'kpi',
          title: 'KPI',
          type: 'basic',
          link: `${baseUrl}/kpi`
        },

        {
          id: 'kpi-compare',
          title: 'KPI Compare',
          type: 'basic',
          link: `${baseUrl}/kpi-compare`
        },
        {
          id: 'ghg-inventory',
          title: 'GHG Inventory',
          type: 'basic',
          link: `${baseUrl}/ghg-inventory`
        },
        {
          id: 'maintenance-schedule',
          title: 'Maintenance Schedule',
          type: 'basic',
          link: `${baseUrl}/maintenance-schedule`
        },
        {
          id: 'implementation-plan',
          title: 'Implementation Plan',
          type: 'basic',
          link: `${baseUrl}/implementation-plan`
        }
      ]
    },
    {
      id: 'data-entry',
      title: 'Data Entry',
      type: 'basic',
      icon: 'data_entry_icon',
      link: `${baseUrl}/data-entry`
    },

    {
      id: 'data-summary',
      title: 'Data Summary',
      icon: 'table_view',
      type: 'basic',
      link: `${baseUrl}/data-summary`
    },
    {
      id: 'data-export',
      title: 'Data Export',
      type: 'basic',
      icon: 'file_save',
      link: `${baseUrl}/data-export`
    },
    {
      id: 'data-import',
      title: 'Data Import',
      type: 'basic',
      icon: 'mat_solid:upload_file',
      link: `${baseUrl}/data-import`
    },
    {
      id: 'project',
      title: 'Project',
      icon: 'project_icon',
      type: 'basic',
      link: `${baseUrl}/project`
    },
    {
      id: 'online-audit',
      title: 'Online Audit',
      icon: 'fact_check',
      type: 'basic',
      link: `${baseUrl}/online-audit`
    },
    {
      id: 'scope-3-data-entry',
      title: 'Scope 3 Data Entry',
      icon: 'data_entry_icon',
      type: 'basic',
      link: `${baseUrl}/scope-3-data-entry`
    },
    {
      id: 'esg',
      title: 'ESG',
      icon: 'heroicons_outline:shield-check',
      type: 'collapsable',
      children: [
        {
          id: 'esg-social',
          title: 'Social',
          type: 'basic',
          link: `${baseUrl}/esg/esg-social`
        },
        {
          id: 'esg-governance',
          title: 'Governance',
          type: 'basic',
          link: `${baseUrl}/esg/esg-governance`
        }
      ]
    },
    {
      id: 'configuration',
      title: 'Configuration',
      type: 'basic',
      icon: 'heroicons_solid:cog',
      link: `${baseUrl}/configuration`
    },
    {
      id: 'connection',
      title: 'Connection',
      type: 'basic',
      icon: 'people_alt',
      link: `${baseUrl}/connection`
    },
    {
      id: 'documentation',
      title: 'Documentation',
      type: 'basic',
      icon: 'heroicons_outline:book-open',
      link: `${baseUrl}/documentation`
    }
  ];

  return navigationList;
};

const getConsultantNavigationForMobile = (baseUrl: string = ''): FuseNavigationItem[] => {
  const navigationList: FuseNavigationItem[] = [
    {
      id: 'project',
      title: 'Projects',
      type: 'basic',
      icon: 'heroicons_outline:chart-pie',
      link: `${baseUrl}/project`
    },
    {
      id: 'audit',
      title: 'Audit',
      type: 'basic',
      icon: 'fact_check',
      link: `${baseUrl}/audit`
    },
    {
      id: 'connection',
      title: 'Connection',
      type: 'basic',
      icon: 'heroicons_outline:users',
      link: `${baseUrl}/connection`
    },
    {
      id: 'settings',
      title: 'Settings',
      type: 'basic',
      icon: 'heroicons_outline:cog',
      link: `${baseUrl}/settings`
    }
  ];
  return navigationList;
};

const getConsultantNavigationForDesktop = (baseUrl: string = ''): FuseNavigationItem[] => {
  const navigationList: FuseNavigationItem[] = [
    {
      id: 'project',
      title: 'Projects',
      type: 'basic',
      icon: 'heroicons_outline:chart-pie',
      link: `${baseUrl}/project`
    },
    {
      id: 'audit',
      title: 'Audit',
      type: 'basic',
      icon: 'fact_check',
      link: `${baseUrl}/audit`
    },
    {
      id: 'connection',
      title: 'Connection',
      type: 'basic',
      icon: 'heroicons_outline:users',
      link: `${baseUrl}/connection`
    },

    {
      id: 'settings',
      title: 'Settings',
      type: 'basic',
      icon: 'heroicons_outline:cog',
      link: `${baseUrl}/settings`
    },
    {
      id: 'help',
      title: 'Documentation',
      type: 'basic',
      icon: 'heroicons_outline:book-open',
      link: `${baseUrl}/documentation`
    }
  ];
  return navigationList;
};
const getConsultantUserNavigationForDesktop = (baseUrl: string = ''): FuseNavigationItem[] => {
  const navigationList: FuseNavigationItem[] = [
    {
      id: 'project',
      title: 'Projects',
      type: 'basic',
      icon: 'heroicons_outline:chart-pie',
      link: `${baseUrl}/project`
    },
    {
      id: 'audit',
      title: 'Audit',
      type: 'basic',
      icon: 'fact_check',
      link: `${baseUrl}/audit`
    },
    {
      id: 'connection',
      title: 'Connection',
      type: 'basic',
      icon: 'heroicons_outline:users',
      link: `${baseUrl}/connection`
    },

    {
      id: 'help',
      title: 'Documentation',
      type: 'basic',
      icon: 'heroicons_outline:book-open',
      link: `${baseUrl}/documentation`
    }
  ];
  return navigationList;
};

const getBrandNavigationForMobile = (
  baseUrl: string = '',
  isLockedMenu: boolean = false
): FuseNavigationItem[] => {
  const navigationList: FuseNavigationItem[] = [
    {
      id: 'dashboard',
      title: isLockedMenu ? 'Dashboard 🔒' : 'Dashboard',
      type: 'basic',
      link: isLockedMenu ? '' : `${baseUrl}/dashboard`,
      exactMatch: true
    },
    {
      id: 'footprint-kpi',
      title: isLockedMenu ? 'Footprint & KPI 🔒' : 'Footprint & KPI',
      type: 'basic',
      link: isLockedMenu ? '' : `${baseUrl}/footprint-and-kpi`
    },
    {
      id: 'compare',
      title: isLockedMenu ? 'Compare 🔒' : 'Compare',
      type: 'basic',
      link: isLockedMenu ? '' : `${baseUrl}/compare`
    },

    {
      id: 'factory-production',
      title: isLockedMenu ? 'Suppliers Production 🔒' : 'Suppliers Production',
      type: 'basic',
      link: isLockedMenu ? '' : `${baseUrl}/factory-production`
    },

    {
      id: 'connection',
      title: 'Connection & Tag',
      type: 'basic',
      link: `${baseUrl}/connection`
    },
    {
      id: 'project',
      title: isLockedMenu ? 'Project 🔒' : 'Project',
      type: 'basic',
      link: isLockedMenu ? '' : `${baseUrl}/project`
    }
  ];
  return navigationList;
};

const getBrandNavigationForMobileUser = (
  baseUrl: string = '',
  isLockedMenu: boolean = false
): FuseNavigationItem[] => {
  const navigationList: FuseNavigationItem[] = [
    {
      id: 'footprint-kpi',
      title: isLockedMenu ? 'Footprint & KPI 🔒' : 'Footprint & KPI',
      type: 'basic',
      link: isLockedMenu ? '' : `${baseUrl}/footprint-and-kpi`
    },
    {
      id: 'compare',
      title: isLockedMenu ? 'Compare 🔒' : 'Compare',
      type: 'basic',
      link: isLockedMenu ? '' : `${baseUrl}/compare`
    },

    {
      id: 'factory-production',
      title: isLockedMenu ? 'Suppliers Production 🔒' : 'Suppliers Production',
      type: 'basic',
      link: isLockedMenu ? '' : `${baseUrl}/factory-production`
    },

    {
      id: 'connection',
      title: 'Connection',
      type: 'basic',
      link: `${baseUrl}/connection`
    },
    {
      id: 'project',
      title: isLockedMenu ? 'Project 🔒' : 'Project',
      type: 'basic',
      link: isLockedMenu ? '' : `${baseUrl}/project`
    }
  ];
  return navigationList;
};

const getBrandNavigationForDesktop = (
  baseUrl: string = '',
  isLockedMenu: boolean = false
): FuseNavigationItem[] => {
  const navigationList: FuseNavigationItem[] = [
    {
      id: 'dashboard',
      title: isLockedMenu ? 'Dashboard 🔒' : 'Dashboard',
      type: 'basic',
      icon: 'mat_solid:dashboard',
      link: isLockedMenu ? '' : `${baseUrl}/dashboard`,
      exactMatch: true
    },

    {
      id: 'home',
      title: 'Supplier Tracking',
      type: 'collapsable',
      icon: 'mat_solid:insights',
      link: '/footprint-and-kpi',
      children: [
        {
          id: 'footprint-kpi',
          title: isLockedMenu ? 'Footprint & KPI 🔒' : 'Footprint & KPI',
          type: 'basic',
          link: isLockedMenu ? '' : `${baseUrl}/footprint-and-kpi`
        },

        {
          id: 'compare',
          title: isLockedMenu ? 'Compare 🔒' : 'Compare',
          type: 'basic',
          link: isLockedMenu ? '' : `${baseUrl}/compare`
        },
        {
          id: 'ghg-inventory',
          title: isLockedMenu ? 'GHG Inventory 🔒' : 'GHG Inventory',
          type: 'basic',
          link: isLockedMenu ? '' : `${baseUrl}/ghg-inventory`
        },
        // 		? "SuppliersKPI Compare 🔒"
        // 		: "SuppliersKPI Compare",
        // 	// tooltip: isLockedMenu ? "Connection with Suppliersrequired" : "",
        // 	// tooltip: isLockedMenu ? "Connection with Suppliersrequired" : "",

        {
          id: 'factory-production',
          title: isLockedMenu ? 'Supplier Production 🔒' : 'Supplier Production',
          type: 'basic',
          link: isLockedMenu ? '' : `${baseUrl}/factory-production`
        },
        {
          id: 'factory-summary',
          title: isLockedMenu ? 'Supplier Data Summary 🔒' : 'Supplier Data Summary',
          type: 'basic',
          link: isLockedMenu ? '' : `${baseUrl}/factory-summary`
        },
        {
          id: 'cluster',
          title: isLockedMenu ? 'Cluster 🔒' : 'Cluster',
          type: 'basic',
          link: isLockedMenu ? '' : `${baseUrl}/cluster`
        },
        // 	// tooltip: isLockedMenu ? "Connection with Suppliersrequired" : "",
        {
          id: 'factory-overview',
          title: isLockedMenu ? 'Supplier Overview 🔒' : 'Supplier Overview',
          type: 'basic',
          link: isLockedMenu ? '' : `${baseUrl}/factory-overview`
        }
      ]
    },
    {
      id: 'data-export',
      title: isLockedMenu ? 'Data Export 🔒' : 'Data Export',
      type: 'basic',
      icon: 'share',
      link: isLockedMenu ? '' : `${baseUrl}/data-export`
    },
    // 		? "Pre-Supplier Prod. Footprint 🔒"
    // 		: "Pre-Supplier Prod. Footprint",
    // 	// tooltip: isLockedMenu ? "Connection with Suppliersrequired" : "",

    // 	// tooltip: isLockedMenu ? "Connection with Suppliersrequired" : "",
    /* brand order will go to the prod in next push */
    {
      id: 'connection',
      title: 'Connection & Tag',
      icon: 'people_alt',
      type: 'basic',
      link: `${baseUrl}/connection`
    },
    {
      id: 'project',
      title: isLockedMenu ? 'Project 🔒' : 'Project',
      icon: 'project_icon',
      type: 'basic',
      link: isLockedMenu ? '' : `${baseUrl}/project`
    },
    {
      id: 'settings',
      title: 'Settings',
      icon: 'settings',
      type: 'basic',
      link: `${baseUrl}/settings`
    },
    {
      id: 'documentation',
      title: 'Documentation',
      type: 'basic',
      icon: 'heroicons_outline:book-open',
      link: `${baseUrl}/documentation`
    }
  ];
  return navigationList;
};

const getBrandNavigationForDesktopUser = (
  baseUrl: string = '',
  isLockedMenu: boolean = false
): FuseNavigationItem[] => {
  const navigationList: FuseNavigationItem[] = [
    {
      id: 'dashboard',
      title: isLockedMenu ? 'Dashboard 🔒' : 'Dashboard',
      type: 'basic',
      icon: 'mat_solid:dashboard',
      link: isLockedMenu ? '' : `${baseUrl}/dashboard`,
      exactMatch: true
    },
    {
      id: 'home',
      title: 'Supplier Tracking',
      type: 'collapsable',
      icon: 'mat_solid:insights',
      link: '/footprint-and-kpi',
      children: [
        {
          id: 'footprint-kpi',
          title: isLockedMenu ? 'Footprint & KPI 🔒' : 'Footprint & KPI',
          type: 'basic',
          link: isLockedMenu ? '' : `${baseUrl}/footprint-and-kpi`
        },

        {
          id: 'compare',
          title: isLockedMenu ? 'Compare 🔒' : 'Compare',
          type: 'basic',
          link: isLockedMenu ? '' : `${baseUrl}/compare`
        },
        {
          id: 'ghg-inventory',
          title: isLockedMenu ? 'GHG Inventory 🔒' : 'GHG Inventory',
          type: 'basic',
          link: isLockedMenu ? '' : `${baseUrl}/ghg-inventory`
        },
        // 		? "SuppliersKPI Compare 🔒"
        // 		: "SuppliersKPI Compare",
        // 	// tooltip: isLockedMenu ? "Connection with Suppliersrequired" : "",
        // 	// tooltip: isLockedMenu ? "Connection with Suppliersrequired" : "",

        {
          id: 'factory-production',
          title: isLockedMenu ? 'Supplier Production 🔒' : 'Supplier Production',
          type: 'basic',
          link: isLockedMenu ? '' : `${baseUrl}/factory-production`
        },
        {
          id: 'factory-summary',
          title: isLockedMenu ? 'Supplier Data Summary 🔒' : 'Supplier Data Summary',
          type: 'basic',
          link: isLockedMenu ? '' : `${baseUrl}/factory-summary`
        },
        {
          id: 'cluster',
          title: isLockedMenu ? 'Cluster 🔒' : 'Cluster',
          type: 'basic',
          link: isLockedMenu ? '' : `${baseUrl}/cluster`
        },
        // 	// tooltip: isLockedMenu ? "Connection with Suppliersrequired" : "",
        {
          id: 'factory-overview',
          title: isLockedMenu ? 'Supplier Overview 🔒' : 'Supplier Overview',
          type: 'basic',
          link: isLockedMenu ? '' : `${baseUrl}/factory-overview`
        }
      ]
    },
    {
      id: 'data-export',
      title: isLockedMenu ? 'Data Export 🔒' : 'Data Export',
      type: 'basic',
      icon: 'share',
      link: isLockedMenu ? '' : `${baseUrl}/data-export`
    },
    // 		? "Pre-Supplier Prod. Footprint 🔒"
    // 		: "Pre-Supplier Prod. Footprint",
    // 	// tooltip: isLockedMenu ? "Connection with Suppliersrequired" : "",

    // 	// tooltip: isLockedMenu ? "Connection with Suppliersrequired" : "",
    /* brand order will go to the prod in next push */
    {
      id: 'connection',
      title: 'Connection & Tag',
      icon: 'people_alt',
      type: 'basic',
      link: `${baseUrl}/connection`
    },
    {
      id: 'project',
      title: isLockedMenu ? 'Project 🔒' : 'Project',
      icon: 'project_icon',
      type: 'basic',
      link: isLockedMenu ? '' : `${baseUrl}/project`
    },

    {
      id: 'documentation',
      title: 'Documentation',
      type: 'basic',
      icon: 'heroicons_outline:book-open',
      link: `${baseUrl}/documentation`
    }
  ];
  return navigationList;
};

const adminNavigationForDesktop: FuseNavigationItem[] = [
  {
    id: 'admin-dashboard',
    title: 'Dashboard',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/dashboard'
  },
  {
    id: 'organization-manage',
    title: 'Organization Manage',
    type: 'basic',
    icon: 'corporate_fare',
    link: '/organization-manage'
  },
  {
    id: 'user-manage',
    title: 'User Manage',
    type: 'collapsable',
    icon: 'users_icon',
    children: [
      {
        id: 'user-manage',
        title: 'Registered User',
        type: 'basic',
        link: '/user-manage/registered-user'
      },
      {
        id: 'user-manage',
        title: 'Guest User',
        type: 'basic',
        link: '/user-manage/guest-user'
      }
    ]
  },
  {
    id: 'connection',
    title: 'Connection',
    type: 'collapsable',
    icon: 'heroicons_solid:switch-horizontal',
    children: [
      {
        id: 'connection',
        title: 'Tag',
        type: 'basic',

        link: '/admin-factory-tag'
      },
      {
        id: 'connection',
        title: 'Connection',
        type: 'basic',

        link: '/connection'
      }
    ]
  },
  {
    id: 'conversion-factor',
    title: 'Conversion Factor',
    type: 'basic',
    icon: 'heroicons_solid:scale',
    link: '/conversion-factor'
  },
  {
    id: 'type-and-department',
    title: 'Unit Type & Department',
    type: 'basic',
    icon: 'department_icon',
    link: '/type-and-department'
  },
  {
    id: 'module',
    title: 'Module & Source',
    type: 'collapsable',
    icon: 'modules_icon',
    children: [
      {
        id: 'module',
        title: 'Modules',
        type: 'basic',
        link: '/module-manage'
      },
      {
        id: 'module',
        title: 'Sources',
        type: 'basic',
        link: '/source-manage'
      }
    ]
  },
  {
    id: 'scope-3',
    title: 'Scope 3',
    type: 'collapsable',
    icon: 'co2-emission',
    children: [
      {
        id: 'scope-3',
        title: 'Scope Three Modules',
        type: 'basic',
        link: '/scope-3'
      },
      {
        id: 'scope-3',
        title: 'Scope Three Sources',
        type: 'basic',
        link: '/source-scope-three'
      }
    ]
  },
  {
    id: 'audit',
    title: 'Audit',
    type: 'basic',
    icon: 'fact_check',
    link: `/audit`
  },
  {
    id: 'verification-standard',
    title: 'Verification Standard',
    type: 'basic',
    icon: 'view_timeline',
    link: `/verification-standard`
  },

  {
    id: 'automated-verification-scope',
    title: 'Automated Verification Scope',
    type: 'basic',
    icon: 'heroicons_solid:badge-check',
    link: '/automated-verification/scope'
  },

  {
    id: 'chemical-management-question-type',
    title: 'Chemical Management',
    type: 'collapsable',
    icon: 'experiment',
    children: [
      {
        id: 'chemical-management',
        title: 'Question List',
        type: 'basic',
        link: '/chemical-management/questions'
      },
      {
        id: 'chemical-management-question-attributes',
        title: 'Question Attributes',
        type: 'basic',
        link: '/chemical-management/question-attributes'
      }
    ]
  },
  {
    id: 'esg',
    title: 'ESG',
    type: 'collapsable',
    icon: 'experiment',
    children: [
      {
        id: 'esg-criteria',
        title: 'Criteria',
        type: 'basic',
        link: '/esg/criteria'
      },
      {
        id: 'esg-questions',
        title: 'Questions',
        type: 'basic',
        link: '/esg/questions'
      }
    ]
  },
  {
    id: 'subscription-plan',
    title: 'Plan & Feature',
    type: 'collapsable',
    icon: 'mat_solid:price_change',
    children: [
      {
        id: 'subscription-plan',
        title: 'Billing & Plan',
        type: 'basic',
        link: '/subscription-plan'
      },
      {
        id: 'feature',
        title: 'Feature',
        type: 'basic',
        link: '/feature'
      }
    ]
  },

  {
    id: 'email-manage',
    title: 'Email Manage',
    icon: 'mat_solid:email',
    type: 'basic',
    link: '/email-manage'
  },

  {
    id: 'invoice-manage',
    title: 'Invoice Manage',
    type: 'basic',
    icon: 'attach_money',
    link: '/invoice-manage'
  },
  {
    id: 'admin-permission',
    title: 'Permission Manage',
    type: 'basic',
    icon: 'mat_solid:manage_accounts',
    link: '/permission-manage'
  },
  {
    id: 'data-export',
    title: 'Data Export',
    icon: 'share',
    type: 'basic',
    link: '/data-export'
  },
  {
    id: 'file-upload',
    title: 'Upload File',
    type: 'basic',
    icon: 'mat_solid:upload',
    link: '/file-upload'
  },
  {
    id: 'others',
    title: 'Others',
    type: 'collapsable',
    icon: 'mat_solid:list',
    children: [
      {
        id: 'major-buyer-manage',
        title: 'Major Buyer',
        type: 'basic',
        link: '/major-buyer-manage'
      },
      {
        id: 'product-type',
        title: 'Product Type',
        type: 'basic',
        link: '/product-type'
      },

      {
        id: 'manage-region',
        title: 'Region',
        type: 'basic',
        link: '/region-manage'
      },

      {
        id: 'certificate-type',
        title: 'Certificate Type',
        type: 'basic',
        link: '/certificate-type-manage'
      },
      {
        id: 'maintenance-schedule-manage',
        title: 'Maintenance Schedule',
        type: 'basic',
        link: '/maintenance-schedule-manage'
      }
    ]
  }
];

const adminNavigationForMobile: FuseNavigationItem[] = [
  {
    id: 'admin-dashboard',
    title: 'Dashboard',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/dashboard'
  },
  {
    id: 'organization-manage',
    title: 'Organization Manage',
    type: 'basic',
    icon: 'corporate_fare',
    link: '/organization-manage'
  },
  {
    id: 'user-manage',
    title: 'User Manage',
    type: 'collapsable',
    icon: 'users_icon',
    link: '/user-manage',
    children: [
      {
        id: 'registered-user',
        title: 'Registered User',
        type: 'basic',
        link: '/user-manage/registered-user'
      },
      {
        id: 'eligible-user',
        title: 'Eligible User',
        type: 'basic',
        link: '/user-manage/eligible-user'
      },
      {
        id: 'guest-user',
        title: 'Guest User',
        type: 'basic',
        link: '/user-manage/guest-user'
      }
    ]
  },

  {
    id: 'connection',
    title: 'Connection',
    type: 'basic',
    icon: 'heroicons_solid:switch-horizontal',
    link: '/connection'
  },

  {
    id: 'type-and-department',
    title: 'Type & Department',
    type: 'basic',
    icon: 'department_icon',
    link: '/type-and-department'
  },
  {
    id: 'tier-manage',
    title: 'Tier Manage',
    type: 'basic',
    icon: 'department_icon',
    link: '/tier-manage'
  },
  {
    id: 'module',
    title: 'Module',
    type: 'basic',
    icon: 'modules_icon',
    link: '/module-manage'
  },
  {
    id: 'sources',
    title: 'Sources',
    type: 'basic',
    icon: 'heroicons_solid:cube-transparent',
    link: '/source-manage'
  },
  {
    id: 'certificate-type',
    title: 'Certificate Type Manage',
    type: 'basic',
    icon: 'certificate_icon',
    link: '/certificate-type-manage'
  }
];

const associationNavigationForDesktop: FuseNavigationItem[] = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'basic',
    icon: 'mat_solid:dashboard',
    link: `/dashboard`,
    exactMatch: true
  },

  {
    id: 'footprint-kpi',
    title: 'Footprint & KPI',
    type: 'basic',
    icon: 'mat_solid:insights',
    link: `/footprint-and-kpi`
  },
  {
    id: 'factory-summary',
    title: 'Supplier Data Summary',
    type: 'basic',
    link: `/factory-summary`,
    icon: 'mat_solid:list_alt'
  },

  {
    id: 'cluster',
    title: 'Cluster',
    type: 'basic',
    icon: 'mat_solid:map',
    link: `/cluster`
  },
  {
    id: 'connection',
    title: 'Connection',
    type: 'basic',
    icon: 'heroicons_solid:switch-horizontal',
    link: `/connection`
  },
  {
    id: 'settings',
    title: 'Settings',
    type: 'basic',
    icon: 'heroicons_outline:cog',
    link: `/settings`
  }
];

const withRtisMcp = (navigation: FuseNavigationItem[]): FuseNavigationItem[] => [
  ...navigation,
  {
    id: 'rtis-mcp',
    title: 'RTIS AI',
    type: 'basic',
    icon: 'smart_toy',
    link: '/rtis-mcp'
  }
];

export const getNavigationList = (
  userType: string,
  isLockedMenu = false,
  type?: any,
  accessRole?: string
): FuseNavigationItem[] => {
  const deviceType = detectDevice();

  if (deviceType === 'mobile') {
    if (userType === 'admin') {
      if (type === 'from_admin_to_factory') {
        return getFactoryRelatedNavigationForMobile('');
      }
      if (type === 'from_admin_to_consultant') {
        return getConsultantNavigationForMobile('');
      }
      if (type === 'from_admin_to_brand') {
        return getBrandNavigationForMobile('', isLockedMenu);
      } else {
        return withRtisMcp(adminNavigationForMobile);
      }
    } else if (userType === 'factory') {
      return withRtisMcp(getFactoryRelatedNavigationForMobile());
    } else if (userType === 'consultant') {
      return withRtisMcp(getConsultantNavigationForMobile());
    } else if (userType === 'brand') {
      if (accessRole === 'user') {
        return withRtisMcp(getBrandNavigationForMobileUser());
      } else {
        return withRtisMcp(getBrandNavigationForMobile());
      }
    } else if (userType === 'association') {
      return associationNavigationForDesktop;
    }
  } else if (deviceType === 'tablet' || deviceType === 'desktop') {
    if (userType === 'admin') {
      if (type === 'from_admin_to_factory') {
        return getFactoryRelatedNavigationForDesktop('');
      }
      if (type === 'from_admin_to_consultant') {
        return getConsultantNavigationForDesktop('');
      }
      if (type === 'from_admin_to_brand') {
        return getBrandNavigationForDesktop('', isLockedMenu);
      } else {
        return withRtisMcp(adminNavigationForDesktop);
      }
    } else if (userType === 'factory') {
      return withRtisMcp(getFactoryRelatedNavigationForDesktop());
    } else if (userType === 'consultant') {
      if (accessRole === 'user') {
        return withRtisMcp(getConsultantUserNavigationForDesktop());
      }
      return withRtisMcp(getConsultantNavigationForDesktop());
    } else if (userType === 'brand' && !isLockedMenu) {
      if (accessRole === 'user') {
        return withRtisMcp(getBrandNavigationForDesktopUser());
      } else {
        return withRtisMcp(getBrandNavigationForDesktop());
      }
    } else if (userType === 'brand' && isLockedMenu) {
      if (accessRole === 'user') {
        return withRtisMcp(getBrandNavigationForDesktopUser('', isLockedMenu));
      } else {
        return withRtisMcp(getBrandNavigationForDesktop('', isLockedMenu));
      }
    } else if (userType === 'association') {
      return associationNavigationForDesktop;
    }
  }
  return [];
};

const detectDevice = (): string => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'tablet';
  } else if (
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return 'mobile';
  }
  return 'desktop';
};
